import Model from '../models/model';

const model = new Model({
	name: 'UserType',
	gridTitle: 'UserType',
	defaultSort: 'Type',
	disableDelete: true,
	formTitleField: 'Type',
	title: 'User_Type',
	showGridRefreshBtn: true,
	initialValues: {
		IsActive: true
	},
	columns: [
		{ header: 'UniqueId', field: 'UserTypeId', hide: true, isNotformfield: true },
		{ header: 'UserType', field: 'Type', width: 200, required: true, minLength: 2, maxLength: 200, inlineLabelSize: 1 },
		{
			field: 'Description',
			width: 290,
			minLength: 2,
			maxLength: 1000,
			required: true,
			multiline: true,
			rows: 2,
			inlineLabelSize: 1
		},
		{ header: 'Active', field: 'IsActive', type: 'bool', width: 75, inlineLabelSize: 1 },
		{ header: 'ApplicationUser', field: 'IsApplication', type: 'bool', width: 200, isNotformfield: true }
	]
});

export default model.createFormBase();